export default {
  title: 'Pseudo-permission',
  studio: {
    description: 'ตรวจสอบสิทธิ์ตาม Role และจัดการแคชสิทธิ์',
    companyGroup: 'กลุ่มบริษัท',
    roleType: 'ประเภท Role',
    employeeCode: 'รหัสพนักงาน',
    lookup: 'ค้นหาสิทธิ์ตาม Role',
    fetch: 'ดึงข้อมูลสิทธิ์ตาม Role',
    result: 'ผลลัพธ์การเรียกข้อมูล',
    empty: 'ยังไม่มีผลลัพธ์ให้แสดง กรอก Role ID แล้วกดดึงข้อมูลสิทธิ์'
  },
  home: 'หน้าหลัก',
  company: 'บริษัท',
  cache: {
    button: 'เคลียร์ permission cache',
    invalidRoleId:
      'กรุณากรอก role_id เป็นจำนวนเต็มที่ไม่ติดลบและอยู่ในช่วงที่รองรับ',
    success: 'เคลียร์ permission cache ของ role_id {{roleId}} สำเร็จ',
    failed: 'ไม่สามารถเคลียร์ permission cache ได้ กรุณาลองใหม่',
    fetchFailed: 'ไม่สามารถดึงข้อมูล permission ได้',
    hint: 'การเคลียร์ cache ไม่มีผลต่อสิทธิ์ใน session ปัจจุบัน ผู้ใช้ที่เกี่ยวข้องต้องออกจากระบบแล้วเข้าสู่ระบบใหม่เพื่อรับสิทธิ์ล่าสุด ปุ่ม Fetch อ่านข้อมูลจาก PIS โดยตรงและไม่เติม cache'
  },
  'delete-row-modal': {
    title: 'Pseudo-permission',
    content: 'คุณต้องการลบรายการที่เลือกหรือไม่',
    button: {
      accept: 'ใช่',
      cancel: 'ไม่ใช่'
    }
  },
  form: {
    startPeriod: {
      label: 'วันเริ่มต้น',
      placeholder: 'วันเริ่มต้น'
    },
    endPeriod: {
      label: 'วันสิ้นสุด',
      placeholder: 'วันสิ้นสุด'
    }
  }
}
